module.exports = __webpack_public_path__ + "public/images/cbs@2x.56b6bfc6cfc520edcf27222dbc19d8f6.png";